var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact-container"},[_c('company-info'),_c('contact-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }